import { TableCard } from '../../../../components'
import { EmpresasClienteListHeader } from './components/header/EmpresasClienteListHeader'
import { ListFiltersProvider } from './core/ListFiltersProvider'
import { ListViewProvider } from './core/ListViewProvider'
import { QueryRequestProvider } from './core/QueryRequestProvider'
import { QueryResponseProvider } from './core/QueryResponseProvider'
import { EmpresasClienteTable } from './table/EmpresasClienteTable'

const EmpresasClienteList = () => {
  return (
    <TableCard>
      <EmpresasClienteListHeader />
      <EmpresasClienteTable />
    </TableCard>
  )
}

const EmpresasClienteListWrapper = () => (
  <QueryRequestProvider>
    <QueryResponseProvider>
      <ListViewProvider>
        <ListFiltersProvider>
          <EmpresasClienteList />
        </ListFiltersProvider>
      </ListViewProvider>
    </QueryResponseProvider>
  </QueryRequestProvider>
)

export { EmpresasClienteListWrapper }
